// extracted by mini-css-extract-plugin
module.exports = {"item":"style_item__3Xac-","icon":"style_icon__wccGU","setIcon":"style_setIcon__272vI","setIconActive":"style_setIconActive__MTv8E","link":"style_link__3jVpY"};